<template>
  <section class="main-page">
    <div class="container-fluid">
      <div class="grid">
        <div class="col-12 md:col-9">
          <api-data-source :api-path="`components_data/getdashboardcount?date_filter=${formData.date_filter}`" v-slot="record"
            :class="$auth.canView('/users/agents') ? '' : 'sticky-item'">
            <section class="page-section mb-3">
              <div class="container-fluid">
                <div class="grid">
                  <div class="col-12 md:col-12">
                    <div class="">
                      <span class="text-3xl font-bold">Dashboard</span>
                      <span class="text-sm">
                        <Button class="p-button-sm p-button-link p-button-success mx-2 p-0 pb-1"
                          label="Version 1.0.5 • What's New?" @click="
                            app.openPageDialog({
                              page: 'custom/whatsnew',
                              url: `/custom/whatsnew`,
                              closeBtn: true,
                              persistent: true,
                              position: 'bottom',
                            })
                            " /></span>
                      <hr class="my-3" />
                    </div>
                  </div>
                  <div v-if="$auth.canView('/users')" class="col-12 md:col-3 comp-grid">
                    <div class="">
                      <router-link :to="`users`">
                        <div class="card bg-blue-100">
                          <div class="flex justify-content-between">
                            <div class="font-medium text-lg">
                              Platform Users
                            </div>
                            <div>
                              <div class="font-bold text-2xl" v-if="!record.loading">
                                {{ record.response.getcount_systemusers }}
                              </div>
                              <ProgressSpinner v-else style="width: 20px; height: 20px" />
                            </div>
                          </div>
                          <div class="text-500 text-sm"></div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <!-- <div
                    v-if="$auth.canView('/offices')"
                    class="col-12 md:col-3 comp-grid"
                  >
                    <div class="">
                      <router-link :to="`offices`">
                        <div class="card bg-blue-100">
                          <div class="flex justify-content-between">
                            <div class="font-medium text-lg">
                              Offices Listed
                            </div>
                            <div>
                              <div
                                class="font-bold text-2xl"
                                v-if="!record.loading"
                              >
                                {{ record.response.getcount_officeslisted }}
                              </div>
                              <ProgressSpinner
                                v-else
                                style="width: 20px; height: 20px"
                              />
                            </div>
                          </div>
                          <div class="text-500 text-sm"></div>
                        </div>
                      </router-link>
                    </div>
                  </div> -->
                </div>
              </div>
            </section>
            <section v-if="$auth.canView('/complaints')" class="page-section mb-3">
              <div class="container-fluid">
                <div class="grid">
                  <div class="col-12 comp-grid">
                    <div class="flex justify-content-between">
                      <div class="text-2xl font-bold my-3">Complaint Tickets</div>
                      <div class="col md:col-3 hidden-xs">
                        <Dropdown class="w-full" optionLabel="label" optionValue="value" ref="ctrlregion"
                          v-model="formData.date_filter" :options="$menus.date_filterItems" label="Period"
                          placeholder="Period ...">
                        </Dropdown>
                      </div>
                    </div>
                    <hr class="my-3" />
                  </div>
                  <div class="col-12 md:col-3 comp-grid">
                    <div class="">
                      <router-link :to="{ path: '/complaints/index', query: { date_filter:formData.date_filter } }">
                        <div class="card bg-purple-100">
                          <div class="font-medium text-lg mb-3">
                            Total Tickets
                          </div>
                          <div class="flex justify-content-between mb-3">
                            <div style="width: auto">
                              <Avatar icon="pi pi-file-excel" size="large" class="text-white bg-purple-500" />
                            </div>
                            <div>
                              <div class="font-bold text-4xl" v-if="!record.loading">
                                {{ record.response.getcount_totaltickets }}
                              </div>
                              <ProgressSpinner v-else style="width: 20px; height: 20px" />
                            </div>
                          </div>
                          <div class="text-500 text-sm">
                            Total tickets created
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div class="col-12 md:col-3 comp-grid">
                    <div class="">
                      <router-link :to="{ path: '/complaints/index', query: { complaints_status: 'opened', date_filter:formData.date_filter } }">
                        <div class="card bg-cyan-100">
                          <div class="font-medium text-lg mb-3">
                            New Tickets
                          </div>
                          <div class="flex justify-content-between mb-3">
                            <div style="width: auto">
                              <Avatar icon="pi pi-file-excel" size="large" class="text-white bg-cyan-500" />
                            </div>
                            <div>
                              <div class="font-bold text-4xl" v-if="!record.loading">
                                {{ record.response.getcount_newtickets }}
                              </div>
                              <ProgressSpinner v-else style="width: 20px; height: 20px" />
                            </div> 
                          </div>
                          <div class="text-500 text-sm">
                            Newly opened tickets
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div class="col-12 md:col-3 comp-grid">
                    <div class="">
                      <router-link :to="{ path: '/complaints/index', query: { complaints_status: 'closed', date_filter:formData.date_filter } }" >
                        <div class="card bg-green-100">
                          <div class="font-medium text-lg mb-3">
                            Closed Tickets
                          </div>
                          <div class="flex justify-content-between mb-3">
                            <div style="width: auto">
                              <Avatar icon="pi pi-file-excel" size="large" class="text-white bg-green-500" />
                            </div>
                            <div>
                              <div class="font-bold text-4xl" v-if="!record.loading">
                                {{ record.response.getcount_closedtickets }}
                              </div>
                              <ProgressSpinner v-else style="width: 20px; height: 20px" />
                            </div>
                          </div>
                          <div class="text-500 text-sm">
                            Total closed tickets
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div class="col-12 md:col-3 comp-grid">
                    <div class="">
                      <router-link :to="{ path: '/complaints/index', query: { complaints_status: 'in progressd', date_filter:formData.date_filter } }">
                        <div class="card bg-indigo-100">
                          <div class="font-medium text-lg mb-3">
                            In Progress
                          </div>
                          <div class="flex justify-content-between mb-3">
                            <div style="width: auto">
                              <Avatar icon="pi pi-file-excel" size="large" class="text-white bg-indigo-500" />
                            </div>
                            <div>
                              <div class="font-bold text-4xl" v-if="!record.loading">
                                {{ record.response.getcount_inprogresstickets }}
                              </div>
                              <ProgressSpinner v-else style="width: 20px; height: 20px" />
                            </div>
                          </div>
                          <div class="text-500 text-sm">
                            Total tickets in progress
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div class="col-12 md:col-3 comp-grid">
                    <div class="">
                      <router-link :to="{ path: '/complaints/index', query: { complaints_status: 'assigned', date_filter:formData.date_filter } }" >
                        <div class="card bg-orange-100">
                          <div class="font-medium text-lg mb-3">Assigned</div>
                          <div class="flex justify-content-between mb-3">
                            <div style="width: auto">
                              <Avatar icon="pi pi-file-excel" size="large" class="text-white bg-orange-500" />
                            </div>
                            <div>
                              <div class="font-bold text-4xl" v-if="!record.loading">
                                {{ record.response.getcount_assignedtickets }}
                              </div>
                              <ProgressSpinner v-else style="width: 20px; height: 20px" />
                            </div>
                          </div>
                          <div class="text-500 text-sm">
                            Total assigned tickets
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div class="col-12 md:col-3 comp-grid">
                    <div class="">
                      <router-link :to="{ path: '/complaints/index', query: { complaints_status: 'on hold', date_filter:formData.date_filter } }" >
                        <div class="card bg-red-100">
                          <div class="font-medium text-lg mb-3">On Hold</div>
                          <div class="flex justify-content-between mb-3">
                            <div style="width: auto">
                              <Avatar icon="pi pi-file-excel" size="large" class="text-white bg-red-500" />
                            </div>
                            <div>
                              <div class="font-bold text-4xl" v-if="!record.loading">
                                {{ record.response.getcount_onholdtickets }}
                              </div>
                              <ProgressSpinner v-else style="width: 20px; height: 20px" />
                            </div>
                          </div>
                          <div class="text-500 text-sm">
                            Total tickets on hold
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div class="col-12 md:col-3 comp-grid">
                    <div class="">
                      <router-link :to="{ path: '/complaints/index', query: { complaints_status: 'prank', date_filter:formData.date_filter } }" >
                        <div class="card bg-yellow-100">
                          <div class="font-medium text-lg mb-3">Prank</div>
                          <div class="flex justify-content-between mb-3">
                            <div style="width: auto">
                              <Avatar icon="pi pi-file-excel" size="large" class="text-white bg-yellow-500" />
                            </div>
                            <div>
                              <div class="font-bold text-4xl" v-if="!record.loading">
                                {{ record.response.getcount_pranktickets }}
                              </div>
                              <ProgressSpinner v-else style="width: 20px; height: 20px" />
                            </div>
                          </div>
                          <div class="text-500 text-sm">Prank complaints</div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section class="page-section mb-4">
              <div class="container-fluid">
                <div class="grid">
                  <div class="col-12 comp-grid">
                    <div class="">
                      <div class="text-2xl font-bold">Mobile App</div>
                      <hr class="my-3" />
                    </div>
                  </div>
                  <div class="col-12 md:col-4 comp-grid">
                    <div class="">
                      <div class="card surface-200">
                        <div class="flex justify-content-between">
                          <div class="font-medium text-lg">Devices</div>
                          <div>
                            <div class="font-bold text-2xl" v-if="!record.loading">
                              {{ record.response.getcount_activeinstalls }}
                            </div>
                            <ProgressSpinner v-else style="width: 20px; height: 20px" />
                          </div>
                        </div>
                        <div class="text-500 text-sm"></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 md:col-4 comp-grid">
                    <div class="">
                      <div class="card surface-200">
                        <div class="flex justify-content-between">
                          <div class="font-medium text-lg">
                            Registered Users
                          </div>
                          <div>
                            <div class="font-bold text-2xl" v-if="!record.loading">
                              {{
                                record.response
                                  .getcount_customersmobileappaccounts
                              }}
                            </div>
                            <ProgressSpinner v-else style="width: 20px; height: 20px" />
                          </div>
                        </div>
                        <div class="text-500 text-sm"></div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-12 md:col-3 comp-grid">
                    <div class="">
                      <div class="card bg-indigo-100">
                        <div class="flex justify-content-between">
                          <div class="font-medium text-lg">App Feedback</div>
                          <div>
                            <div
                              class="font-bold text-2xl"
                              v-if="!record.loading"
                            >
                              {{ record.response.getcount_appfeedback }}
                            </div>
                            <ProgressSpinner
                              v-else
                              style="width: 20px; height: 20px"
                            />
                          </div>
                        </div>
                        <div class="text-500 text-sm"></div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </section>
          </api-data-source>
          <section v-if="$auth.canView('/users/agents')">
            <div class="container-fluid">
              <div class="grid">
                <div class="col-12 comp-grid">
                  <div class="">
                    <div class="text-2xl font-bold">Live Monitoring</div>
                    <hr class="my-3" />
                  </div>
                </div>
                <div class="col-12">
                  <api-data-source :api-path="`users/agents?id=${formData.session_id}`" :first-record="false"
                    v-slot="req">
                    <div>
                      <DataTable :lazy="true" :loading="loading" :value="req.response.records" dataKey="user_id" class=""
                        :showGridlines="false" :rowHover="true" responsiveLayout="scroll">
                        <Column field="photo" header="Photo">
                          <template #body="{ data }">
                            <image-viewer image-size="medium" image-preview-size="" :src="data.photo" width="30px"
                              height="30px" :num-display="1">
                            </image-viewer>
                          </template>
                        </Column>
                        <Column field="first_name" header="Name" :sortable="true">
                          <template #body="{ data }">
                            {{ data.first_name + " " + data.last_name }}
                          </template>
                        </Column>
                        <Column field="telephone" header="Telephone Ext.">
                          <template #body="{ data }">
                            {{ data.telephone }}
                          </template>
                        </Column>
                        <Column field="sip_status" header="Status">
                          <template #body="{ data }">
                            <span v-if="data.sip_status == 'NOT_INUSE'" class="font-bold text-green-500">
                              {{ $utils.capitalize(data.sip_status) }}
                            </span>
                            <span v-else-if="data.sip_status == 'RINGING'" class="font-bold text-green-500 blink">
                              {{ $utils.capitalize(data.sip_status) }}
                            </span>
                            <span v-else>{{
                              $utils.capitalize(data.sip_status)
                            }}</span>
                          </template>
                        </Column>
                        <Column field="date_updated" header="Last Updated">
                          <template #body="{ data }">
                            {{ $utils.relativeDate(data.date_updated) }}
                          </template>
                        </Column>
                      </DataTable>
                    </div>
                  </api-data-source>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div class="col-12 md:col-3">
          <div class="">
            <template v-if="$auth.canView('/complaints/add')">
              <router-link :to="`/complaints/add`">
                <Button label="Create New Ticket" type="button" class="w-full bg-primary p-button-rounded" />
              </router-link>
            </template>
          </div>
          <hr />
          <div v-if="auth.userDistrict == 'Call Center'" class="">
            <div class="flex align-items-center justify-content-start">
              <div>
                <div class="font-bold text-lg mb-1">Make a Call</div>
                <div class="">
                  Initiate a call to a customer or client on behalf of the call
                  center
                </div>
              </div>
              <div class="mr-2">
                <Avatar size="large" class="primary" icon="pi pi-phone" />
              </div>
            </div>

            <div class="mt-2">
              <div class="flex align-items-center justify-content-start mt-2">
                <div class="w-full">
                  <InputText ref="ctrlphone_number" v-model.trim="formData.phone_number" label="Phone Number" type="text"
                    placeholder="Phone Number" class="w-full" pattern="^[0-9]+$" maxlength="12" minlength="10"
                    v-tooltip.top.focus="'Eg: 0209013836'">
                  </InputText>
                </div>
                <div v-if="formData.phone_number" class="ml-2">
                  <Button class="p-button-rounded p-button-help" icon="pi pi-phone" @click="makeCall" />
                </div>
              </div>
              <div class="grid">
                <div class="col"></div>
              </div>
            </div>
          </div>
          <hr />
          <div class="">
            <api-data-source api-path="components_data/recent_chats_data_repeater">
              <template v-slot="req">
                <div>
                  <div class="pb-2">
                    <div class="flex align-items-center justify-content-start">
                      <div>
                        <div class="font-bold text-lg mb-1">
                          Recent Messages
                        </div>
                        <div class="">
                          Chat messages sent from the Mobile App as follow-up on
                          opened complaint tickets
                        </div>
                      </div>
                      <div class="mr-2">
                        <Avatar size="large" class="primary" icon="pi pi-comments" />
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div>
                    <template v-if="!req.loading">
                      <div class="card" v-for="(data, i) in req.response" :key="i">
                        <div class="mb-2">
                          <div class="font-bold">
                            <router-link :to="`/complaints/view/${data.complaint_id}`">
                              {{ data.ticket_id }}
                            </router-link>
                            <Tag class="ml-2" rounded severity="danger" value="New"></Tag>
                          </div>
                          <div class="mt-2">
                            <Chip :label="data.message" class="mr-2 mb-2 custom-chip" />
                          </div>
                          <div class="text-sm mt-1">
                            {{ $utils.relativeDate(data.date_created) }}
                          </div>
                        </div>
                        <!-- {{ data }} -->
                      </div>
                      <div v-if="req.response.length" class="text-center">
                        <Button @click="req.load" icon="pi pi-refresh" />
                      </div>
                      <div v-if="!req.response.length">
                        <div class="text-gray-400 text-center">
                          No recent chat messages found
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div>
                        <table class="p-datatable-table w-full">
                          <tbody>
                            <tr v-for="n in 3" :key="n">
                              <td class="text-left" style="width: 100%">
                                <Skeleton height="10rem" class="m-2" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </api-data-source>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { useApp } from "@/composables/app.js";
import { useAuth } from "@/composables/auth";
import { utils } from "@/utils";
import { onBeforeUnmount, onMounted, reactive, ref } from "vue";
const props = defineProps({
  pageName: {
    type: String,
    default: "home",
  },
  routeName: {
    type: String,
    default: "home",
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp();
const auth = useAuth();
var refreshInterval;

const formDefaultValues = { phone_number: "", session_id: "0", date_filter: "Today" };
const formData = reactive({ ...formDefaultValues });

const pageReady = ref(true);
onMounted(() => {
  const pageTitle = process.env.VUE_APP_NAME;
  app.setPageTitle(props.routeName, pageTitle);
  triggerAgentRefresh();
});

onBeforeUnmount(() => {
  clearInterval(refreshInterval);
});

function triggerAgentRefresh() {
  clearInterval(refreshInterval);
  if (auth.canView("/users/agents")) {
    refreshInterval = setInterval(function () {
      Object.assign(formData, { session_id: utils.uuid() });
    }, 3000);
  }
}

function makeCall() {
  if (formData.phone_number) {
    app.openCallBackDialog({
      contact: `${formData.phone_number}`,
      description: `You are about to call ${formData.phone_number}. Do you want to continue?`,
    });
    Object.assign(formData, { phone_number: "" });
  }
}
</script>
<style scoped></style>
